var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"heaer-text"},[_vm._v("LT预测表")]),_c('div',{staticClass:"table-wrap"},[_c('lt-filter',{on:{"showLoading":_vm.showLoading,"downloadFile":_vm.downloadFile,"refreshTable":_vm.refreshTable}}),_c('lt-table',{ref:"lttable",attrs:{"column":_vm.column,"fathercolumn":_vm.fathercolumn,"loading":_vm.loading}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }